import { render } from "./eyerweb-patient-show.vue?vue&type=template&id=57862b48"
import script from "./eyerweb-patient-show.vue?vue&type=script&lang=js"
export * from "./eyerweb-patient-show.vue?vue&type=script&lang=js"

import "./eyerweb-patient-show.vue?vue&type=style&index=0&id=57862b48&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__